<mat-card appearance="outlined" *appRoles="['Contactos.Ver']">
  <!-- Cabecera -->
  <mat-card-header>
    <div class="header-nombre-nuevo">
      <h2>Contactos</h2>
      <app-button-new (click)="openDialog({ accion: accionesDialog.Agregar })" *appRoles="['Contactos.Crear']" #tooltip="matTooltip"
        matTooltip="Crear contacto."></app-button-new>
    </div>
  </mat-card-header>

  <!-- Contenido de filtros -->
  <mat-card-content>
    <div class="row align-items-center">
      <div class="col-auto">
        <div style="display: flex; align-items: center; gap: 8px;">
          <app-button-filter-table (click)="aplicarFiltro()"></app-button-filter-table>
          <app-button-filter-table-clear (click)="limpiarFiltro()"></app-button-filter-table-clear>
        </div>
      </div>
      <div class="col-auto">
        <mat-slide-toggle (change)="filtrosAvanzados($event)" color="primary">
          Filtros Avanzados
        </mat-slide-toggle>
      </div>
    </div>
  </mat-card-content>

  <mat-card-content>
    <mat-divider></mat-divider>
    <ngx-spinner [zIndex]="100" name="spListado" bdColor="rgba(255,255,255,0.8)" size="default"
      color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
    </ngx-spinner>

    <!-- Inicio Contenedor acciones tabla -->
    <div class="contenedor-acciones-tablas">
      <div class="acciones-tabla">
        <!-- Boton de Acciones -->
        <!-- <app-button-action></app-button-action> -->
      </div>
      <mat-form-field appearance="outline" *ngIf="data" class="buscador-tabla">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Buscar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar" #input />
      </mat-form-field>
    </div>
    <!-- Fin Contenedor acciones tabla -->

    <!-- Tabla De datos -->
    <div>

      <table class="mat-elevation-z8" mat-table [dataSource]="dataSource" *ngIf="data" matSort matSortStart="asc">
        <ng-container matColumnDef="tipoContacto">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Tipo Contacto</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let contacto">
            <span>{{ contacto.tipoContacto?.descripcion | titlecase }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="valorContacto">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header><strong>Valor</strong></mat-header-cell>
          <mat-cell mat-cell *matCellDef="let contacto">
            <span>
              {{
              contacto.valorContacto == undefined ? "" : contacto.valorContacto
              }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="preferido">
          <mat-header-cell mat-header-cell *matHeaderCellDef mat-sort-header>
            <strong>Preferencia</strong>
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let contacto">
            <span> {{ contacto.preferido == true ? "Si" : "No" }}</span>
          </mat-cell>
        </ng-container>

        <!-- Accion Column -->
        <ng-container matColumnDef="accion">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            <strong>Acción</strong>
          </mat-header-cell>
          <mat-cell *matCellDef="let item" class="action-link">
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Ver, entidad: {item} })">
                <mat-icon>visibility</mat-icon>
                <span>Ver</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Modificar, entidad: {item} })">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="openDialog({ accion: accionesDialog.Eliminar, entidad: {item} })">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row matRipple *matRowDef="let row; columns: displayedColumns"></mat-row>
      </table>

      <app-sin-datos-para-mostrar [dataSource]="dataSource"></app-sin-datos-para-mostrar>

      <mat-paginator showFirstLastButtons class="paginator" *ngIf="data" [pageSize]="20"
        [pageSizeOptions]="[5, 10, 20, 50, 100, 200]">
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
